// RMI-2026-591 (react-refresh/only-export-components): split out of
// SyncContext.jsx, which now exports only the SyncProvider component.
import { createContext, useContext } from 'react';

export const SyncContext = createContext();

export const useSync = () => useContext(SyncContext);
